import { create } from 'zustand';

export interface AIPageContext {
  moduleId?: string;
  url?: string;
  pageTitle?: string;
  breadcrumb?: string[];
  /** 当前页面筛选条件 */
  filters?: Record<string, any>;
  /** 最近操作 */
  recentActions?: string[];
  /** 核心实体类型（如 experiment） */
  entityType?: string;
  /** 核心实体 ID */
  entityId?: string;
  /** 当前选中游戏 code（如 g79） */
  gameId?: string;
}

interface AIContextState {
  ctx: AIPageContext;
  setCtx: (patch: Partial<AIPageContext>) => void;
  reset: () => void;
}

export const useAIContextStore = create<AIContextState>((set) => ({
  ctx: {},
  setCtx: (patch) => set((s) => ({ ctx: { ...s.ctx, ...patch } })),
  reset: () => set({ ctx: {} })
}));
